// 全局组件
import type { App } from 'vue'
import { at } from '@/utils'
import uploader from 'vue-simple-uploader'
export default function initGlobComp(app: App) {
	app.config.globalProperties.$at = at
	app.use(uploader)
}
